export default "__VITE_ASSET__w3SEvb2H__"